module.exports = __webpack_public_path__ + "img/spain-cerebrovascular-disease-male.a53fe4ae.png";